import { render, staticRenderFns } from "./verbal.vue?vue&type=template&id=3133ca27&"
import script from "./verbal.vue?vue&type=script&lang=js&"
export * from "./verbal.vue?vue&type=script&lang=js&"
import style0 from "./verbal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports